import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LangProvider } from "@/contexts/LangContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import SmoothScroll from "@/components/SmoothScroll";

import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Consultations from "@/pages/Consultations";
import BookingResult from "@/pages/BookingResult";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminTransactions from "@/pages/admin/AdminTransactions";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <LangProvider>
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <SmoothScroll>
              <Toaster
              position="top-right"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#1A1918",
                  border: "1px solid #2C2A28",
                  color: "#F4F0EB",
                  borderRadius: 0,
                },
              }}
            />
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="projects" element={<AdminProjects />} />
                <Route path="media" element={<AdminMedia />} />
                <Route path="bookings" element={<AdminBookings />} />
                <Route path="messages" element={<AdminMessages />} />
                <Route path="transactions" element={<AdminTransactions />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>

              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/about" element={<About />} />
                <Route path="/consultations" element={<Consultations />} />
                <Route path="/booking/result" element={<BookingResult />} />
                <Route path="/contact" element={<Contact />} />
              </Route>
            </Routes>
            </SmoothScroll>
          </BrowserRouter>
        </AuthProvider>
      </SettingsProvider>
    </LangProvider>
  );
}

export default App;
